export { ReactComponent as TextItalic } from './svgs/italic.svg';
